"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  props: {
    /* 对话框的打开开关 */
    open: {
      type: Boolean,
      default: false
    },
    /** 对话框设置
      * */
    dialogOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 确定按钮设置 */
    okBtn: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 取消按钮设置 */
    closeBtn: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};